import * as React from "react";
import { Redirect } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { deriveRedirectTarget, TENANTS_ROUTE } from "components/router/Routes";

export default function TenantsView(): JSX.Element {
    const isRouteEnabled = useIsRouteEnabled();

    const target = deriveRedirectTarget(TENANTS_ROUTE, isRouteEnabled);

    return <Redirect to={target.path} />;
}
